import { render, staticRenderFns } from "./XeroWizard.vue?vue&type=template&id=36c5aa12&scoped=true"
import script from "./XeroWizard.vue?vue&type=script&lang=js"
export * from "./XeroWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5aa12",
  null
  
)

export default component.exports